<template>
  <div class="app-search d-none d-lg-block p-0">
    <div class="position-relative">
      <input
          type="text"
          class="form-control"
          :placeholder="placeholder"
          v-model="searchInput"
      />
      <span class="bx bx-search-alt"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "design-search-field",

  props : {
    value : String,
    placeholder : {
      type : String,
      default : "Rechercher..."
    },
  },

  data(){
    return{
      searchInput : this.value
    }
  },

  watch : {
    value : function(){
      this.searchInput = this.value ;
    },

    searchInput : function(){
      this.handleInput() ;
    }
  },

  methods : {
    handleInput(){
      this.$emit('input', this.searchInput) ;
    }
  }
}
</script>

<style scoped>

</style>